'use client';

import { useTranslation } from 'next-i18next';
import { useAuthClient } from '@hooks/common/useAuthClient/useAuthClient';
import { ImageBj } from '@components/common';
import cvWorthLandingHeroImage from '@images/campaigns/cv-worth/cv-worth-landing-hero.png';
import { CvWorthForm } from '@components/templates/forms/cv-worth/Cv-worth-form';

// This is a Client Component (same as components in the `pages` directory)
// It receives data as props, has access to state and effects, and is
// prerendered on the server during the initial page load.
const SalariesPageContent = () => {
  // translation
  const { t } = useTranslation('common');

  // Authentication client side
  const { isAuth } = useAuthClient();

  // circle gradient background
  const bgHeroCardBase = 'bg-surface rounded p-5 lg:px-10 lg:pt-10 lg:grid lg:grid-cols-9 lg:gap-10 lg:items-center xl:px-16 xl:pt-14';
  const bgCircleGradient = 'bg-no-repeat bg-radial-gradient from-secondary/10 from-0% via-secondary/10 via-70% to-surface to-70% bg-clip-border';
  const bgSizes = 'bg-size-square-600px bg-right-top--300 lg:bg-size-square-900px lg:bg-right-bottom--450--550';

  return (
    <div className="flex grow bg-surface-100">
      <div className="container mx-auto p-3">
        <div className={`${bgHeroCardBase} ${bgCircleGradient} ${bgSizes}`}>

          {/* Hero IMAGE */}
          <div className="flex justify-center lg:order-2 lg:col-span-4 xl:pl-10">
            <ImageBj priority src={cvWorthLandingHeroImage} alt="" className="mx-9 lg:mx-0 lg:-mt-9" />
          </div>

          {/* Hero FORM */}
          <div className="mt-7 lg:col-span-5 lg:mt-0">
            <h1 className="text-4xl font-bold">{t('salary.landing.title')}</h1>
            <p className="mb-1.5 mt-5">{t('salary.landing.desc')}</p>
            <CvWorthForm isAuth={isAuth} isSalaryContext />
          </div>

        </div>
      </div>
    </div>
  );
};

export default SalariesPageContent;
